import * as React from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { Box, Button, Typography, Grid } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import './GenerateImageCard.css';
import './GenerateImageCard.css';
import settingLogo from "../../assets/Setting.png"
import Popup from '../Popup/Popup';
import Masonry from "react-masonry-css";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewQuiltIcon from "@mui/icons-material/ViewQuilt";

interface ImageCardProps {
    imageSource: string | string[];
    trainingStatus: string;
    selectedType?: string;
    generatedImages?: any;
    isMobile?: any;
}

const ImageCard: React.FC<ImageCardProps> = ({ imageSource, trainingStatus, generatedImages, isMobile }) => {
    const [hoveredCard, setHoveredCard] = React.useState<number | null>(null);
    const [openDialog, setOpenDialog] = React.useState<boolean>(false);
    const [currentImage, setCurrentImage] = React.useState<string | null>(null);
    const [viewType, setViewType] = React.useState<'grid' | 'masonry'>('masonry');
    const [imagePrompt, setImagePrompt] = React.useState<string | null>(null);

    const handleMouseEnter = (index: number) => {
        setHoveredCard(index);
    };

    const handleMouseLeave = () => {
        setHoveredCard(null);
    };

    const handlePreviewClick = (image: string) => {
        setCurrentImage(image);
        setOpenDialog(true);
    
        const matchedImage = generatedImages?.find((item: any) => item.url === image);
        if (matchedImage) {
            setImagePrompt(matchedImage.prompt); 
        } else {
            setImagePrompt(null); 
        }
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setCurrentImage(null);
    };
    // const downloadImage = async (blobUrl: any) => {
    //     console.log('blob', blobUrl);
    //     try {
    //         const response = await axios.get(blobUrl, {
    //             responseType: 'blob',
    //             timeout: 30000
    //         });
    //         const blob = new Blob([response.data], { type: response.headers["content-type"] });
    //         const url = window.URL.createObjectURL(blob);
    //         const link = document.createElement('a');
    //         link.href = url;axios
    //         link.setAttribute('download', `${name}.png`);
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //         window.URL.revokeObjectURL(url); // Clean up
    //     } catch (error) {
    //         console.error('Error downloading the image:', error);
    //     }
    // };

    const BG_IMAGE_URL = "https://showcasaai.blob.core.windows.net/assets/bg_image.png";

    if (Array.isArray(imageSource) && imageSource.length > 0) {
        return (
            <Box sx={{ overflowY: 'auto', height: 'calc(100vh - 180px)', width: '100%' }}>
                <Box sx={{ display: 'flex', gap: 1, mb: 2, mt: 2, justifyContent: 'flex-end' }}>
                    {viewType === "masonry" ?
                        <ViewModuleIcon className="iconColor" onClick={() => setViewType('grid')} /> :
                        <ViewQuiltIcon className="iconColor" onClick={() => setViewType('masonry')} />
                    }
                </Box>
                {viewType === 'grid' ? (
                    <Grid container spacing={1}>
                        {imageSource.map((image, index) => {
                            const isBgImage = index === 0 && image === BG_IMAGE_URL;
                            return (
                                <Grid item xs={12} sm={6} md={3} lg={3} key={image}>
                                    <Card
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: isBgImage ? "#444" : "#2d2d55",
                                            color: "#ffffff",
                                            borderRadius: "16px",
                                            cursor: isBgImage ? "not-allowed" : "pointer",
                                            marginTop: 2,
                                            marginLeft: 2,
                                            position: 'relative',
                                            opacity: isBgImage ? 0.5 : 1,
                                        }}
                                        onMouseEnter={isBgImage ? undefined : () => handleMouseEnter(index)}
                                        onMouseLeave={isBgImage ? undefined : handleMouseLeave}
                                    >
                                        <CardMedia
                                            component="img"
                                            image={image}
                                            alt={`Card Image ${index + 1}`}
                                            height={300}
                                            width={179}
                                            sx={{
                                                objectFit: "cover",
                                            }}
                                        />
                                        {!isBgImage && hoveredCard === index && (
                                            <React.Fragment>
                                                <Box sx={styles.overlay} />
                                                <Box sx={styles.iconLayout}></Box>
                                                <Box sx={styles.buttonContainer}>
                                                    <Button
                                                        sx={styles.previewButton}
                                                        onClick={() => handlePreviewClick(image)}
                                                    >
                                                        <VisibilityIcon sx={styles.iconColor} />
                                                        <Typography sx={styles.previewText}>Preview</Typography>
                                                    </Button>
                                                </Box>
                                            </React.Fragment>
                                        )}
                                    </Card>
                                </Grid>
                            );
                        })}
                    </Grid>
                ) : (
                    <Masonry
                        breakpointCols={{ default: 5, 1100: 3, 700: 3, 500: 2, 400: 1 }}
                        className="my-masonry-grids"
                        columnClassName="my-masonry-grid_column"
                        style={{ width: '100%' }}
                    >
                        {imageSource.map((image, index) => {
                            const isBgImage = index === 0 && image === BG_IMAGE_URL;
                            return (
                                <Card
                                    key={image}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: isBgImage ? "#444" : "#2d2d55",
                                        color: "#ffffff",
                                        borderRadius: "16px",
                                        cursor: isBgImage ? "not-allowed" : "pointer",
                                        marginTop: 2,
                                        marginLeft: 2,
                                        position: 'relative',
                                        opacity: isBgImage ? 0.5 : 1,
                                    }}
                                    onMouseEnter={isBgImage ? undefined : () => handleMouseEnter(index)}
                                    onMouseLeave={isBgImage ? undefined : handleMouseLeave}
                                >
                                    <CardMedia
                                        component="img"
                                        image={image}
                                        alt={`Card Image ${index + 1}`}
                                        sx={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                        }}
                                    />
                                    {!isBgImage && hoveredCard === index && (
                                        <React.Fragment>
                                            <Box sx={styles.overlay} />
                                            <Box sx={styles.iconLayout}></Box>
                                            <Box sx={styles.buttonContainer}>
                                                <Button
                                                    sx={styles.previewButton}
                                                    onClick={() => handlePreviewClick(image)}
                                                >
                                                    <VisibilityIcon sx={styles.iconColor} />
                                                    <Typography sx={styles.previewText}>Preview</Typography>
                                                </Button>
                                            </Box>
                                        </React.Fragment>
                                    )}
                                </Card>
                            );
                        })}
                    </Masonry>
                )}
                {openDialog && (
                    <Popup
                        open={openDialog}
                        onClose={handleCloseDialog}
                        leftPromptText={imagePrompt ?? ""}
                        previewImageSrc={currentImage ?? undefined}
                        leftColumnType='prompt'
                        rightColumnType='image'
                    />
                )}
            </Box>
        );
    }

    return trainingStatus ? null : (
        <Box className="container">
            <img src={settingLogo} alt="settingIcon" />
            <Typography className='title'>No trained images</Typography>
            <Typography className='description'>
                Please upload and train your images first to generate with prompt.
            </Typography>
            {/* <Button className='trainButton'
            >
                <SettingsSuggestIcon />
                <Typography variant="body1">
                    Train
                </Typography>
            </Button> */}
        </Box>
    );
};

export default ImageCard;

const styles = {
    cardContainer: {
        margin: '5px',
        backgroundColor: 'gray',
        cursor: 'pointer',
        position: 'relative',
        // '@media (max-width: 768px)': {
        //     width: '100%',
        // },
        // '@media (min-width: 768px)': {
        //     width: 'calc(50% - 10px)',
        // },
        // '@media (min-width: 1024px)': {
        //     width: 'calc(33.33% - 10px)',
        // },
        // '@media (min-width: 1200px)': {
        //     width: 'calc(19% - 10px)',
        // },
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1,
    },
    iconLayout: {
        display: 'flex',
        gap: '5px',
        justifyContent: 'right',
        margin: 2,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2,
    },
    iconColor: {
        color: '#fff',
        fontSize: '15px',
    },
    previewButton: {
        backgroundColor: '#69319D',
        '&:hover': { backgroundColor: '#69319D' },
        color: '#fff',
        fontWeight: 'bold',
        fontSize: '12px',
        fontFamily: 'var(--font-family-primary)',
        borderRadius: 4,
        display: 'flex',
        justifyContent: 'space-evenly',
        width: '50%',
        zIndex: 2,
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        left: 0,
        right: 0,
        top: '45%',
        zIndex: 2,
    },
    previewText: {
        fontSize: '12px',
        fontFamily: 'var(--font-family-primary)',
        fontWeight: 400,
        color: '#fff',
        textTransform: "none",

    },
};